// extracted by mini-css-extract-plugin
export var standaloneTable = "_ft-0";
export var standaloneTableWithBodyFill = "_ft-1";
export var withExtraHeader = "_ft-2";